import React from "react";
import styles from "./styles.module.scss";
import { Heading } from "components";

const PROPERTY_CODE = "URK3WM";

const SectionOne = () => {
	return (
		<div className={`column0 ${styles.template1}`}>
			<Heading
				heading="book a suite"
				color="white"
				className={styles.template1__heading}
			/>
			<hr />

			<div className={styles.template1__frame}>
				<cb-immersive-experience
					mode="standard"
					property-code={PROPERTY_CODE}
				/>
			</div>
		</div>
	);
};

export { SectionOne };
